"use strict";
import GlobalUtil from "../utils/pricetravel/shared/globalUtil";
import LowPriceNotifierService from "../utils/pricetravel/shared/lowPriceNotifierService";
import ListUtil from "../utils/pricetravel/list/utils";
import FavsTracker from '../MetricsTracker/favorite/metrics';
import MealPlanNormalizer from '../utils/pricetravel/shared/MealPlanNormalizer';
window.app.controller("FavoriteController", controller);

controller.$inject = [
    "$scope",
    "$timeout"
];

function controller($scope,$timeout) {
    let vm = this;
    let config = window.__pt.settings.site;
    let fn = window.__pt.fn;
    let _separator = "...";
    let isMobile = fn.mobileAndTabletCheck();
    let _paramQuery = fn.search();
    let _user = window.__pt.user || null;
    let _isLogin = !!_user;
    let _globalUtil = new GlobalUtil(_paramQuery, config);
    let _userKey = _globalUtil.getUserKeyFavorites();
    let _listUtil = new ListUtil(_paramQuery, config, _separator);
    let ln = window.__pt.ln || {};
    let configDaysPrequote = {
        weeksPrequote: 0,
        daysPrequote: 0,
        startDate: 0,
    };
    let setting = window.__pt.settings;
    vm.ln = ln;
    let tracker = new FavsTracker();
    // Initialize the service
    const service = new LowPriceNotifierService(config.domainAPIUrl);
    const culture = window.__pt.cultureData;

    // Initialize alerts
    vm.alertsFavorites = {
        notificationSuccess: false,
        notificationError: false,
        notificationWarning: false,
        message: "",
        actionType: "", // 'save' or 'delete'
    };
    vm.urlHotels = `${culture.cultureCode}${ln.uriHotels}`;
    vm.mealplans = vm.mealplans = MealPlanNormalizer.normalizeAll(ln.mealplans, config.siteName);;
    vm.currency = config.currencySymbol || "";
    vm.favoriteHotels = [];
    vm.groupedFavoriteHotels = [];
    vm.loadingRates = true;
    vm.hotelToRemove = null;
    vm.hotelToRemoveCopy = null;
    vm.hideNotificationTimeout = null;
    vm.hasCheaperHotels = false;
    vm.showTimer = false;
    vm.allCheckinsExpired = false;

    vm.countTotalPersons = function (rooms) {
        let totalPersons = 0;
        rooms.forEach((room) => {
            totalPersons += room.adults;
            totalPersons += room.children.length;
        });
        return totalPersons;
    };

    vm.checkForCheaperHotels = function () {
        vm.hasCheaperHotels = vm.favoriteHotels
            .filter((hotel) => hotel.checkin && hotel.checkin.trim() !== '')
            .some((hotel) => hotel.totalRoomRatePerNight < hotel.originalPrice);
    };
    function onLoadRates() {

        const newDateParse = new Date(fn.getDate());
        newDateParse.setDate(
            newDateParse.getDate() + configDaysPrequote.weeksPrequote * 7
        );
        newDateParse.setDate(
            newDateParse.getDate() -
            newDateParse.getDay() +
            configDaysPrequote.startDate
        );

        const request = {
            UserId: _userKey,
            //country: config.country.toUpperCase(),
            culture: culture.internalCultureCode,
            propertyId: config.property,
            mobile: fn.mobileAndTabletCheck(),
            organizationId: config.organization,
            source: "SPA-Hotel-List",
            login: _isLogin,
            defaultDate: getInitialDate(newDateParse)
        };

        service
            .getHotelsByUserFacade(request)
            .then((response) => {
                $scope.$applyAsync(() => {
                    vm.loadingRates = false;
                    vm.favoriteHotels = response.value;
                    vm.favoriteHotels.forEach((favoriteHotel) => {
                        let pax = fn.mapPaxToUrlOriginal(mapPaxToRoomsInverse(favoriteHotel.rooms));
                        let checkIn = fn.getDate(favoriteHotel.checkin);
                        let checkOut = fn.getDate(favoriteHotel.checkout);
                        let daysDiff = fn.diffBetweenDays(checkIn, checkOut);


                        let paramsUri = {
                            checkin: favoriteHotel.checkin,
                            checkout: favoriteHotel.checkout,
                            placetype: favoriteHotel.placeType,
                            placeid: favoriteHotel.id,
                            source: favoriteHotel.source ? favoriteHotel.source : "",
                            daysDiff: daysDiff,
                        };
                        let paramsUriConcat = { ...paramsUri, ...pax };
                        let query = fn.objectToQueryParams(paramsUriConcat);
                        favoriteHotel.url = _listUtil.getUrlToDetail(favoriteHotel, query);
                        favoriteHotel.totalRooms = favoriteHotel.totalRooms == 0 ? favoriteHotel.rooms.length : favoriteHotel.totalRooms;
                        favoriteHotel.daysDiff = daysDiff;
                    });
                    vm.updateHotelsState();
                    vm.checkForCheaperHotels();
                });
            })
            .catch((error) => {
                vm.loadingRates = false;
                console.error("Error fetching hotels by user:", error);
            });
    }
    function mapPaxToRoomsInverse(paxes) {
        return paxes.map(pax => ({
            adults: pax.adults,
            children: pax.children.map(child => ({ year: child }))
        }));
    }

    function groupHotelsByPlaceId(hotels) {
        const grouped = hotels.reduce((acc, hotel) => {
            if (!acc[hotel.placeId]) {
                acc[hotel.placeId] = {
                    placeName: hotel.placeName,
                    placeUri: hotel.placeUri,
                    placeId: hotel.placeId,
                    rotate: true,
                    hotels: [],
                };
            }

            acc[hotel.placeId].hotels.push(hotel);
            return acc;
        }, {});
        vm.allCheckinsExpired = hotels.every(h => h.checkin == null);
        vm.checkForCheaperHotels();
        return Object.values(grouped);
    }

    vm.updateHotelsState = function () {
        vm.groupedFavoriteHotels = groupHotelsByPlaceId(vm.favoriteHotels);
    };
    vm.openFavoritesEvent = (hotel) => {
        tracker.logOpenFav(hotel, 'favsList', vm.favoriteHotels.length,);
    }
    vm.showNotification = (type, message, actionType) => {
        if (vm.hideNotificationTimeout) {
            $timeout.cancel(vm.hideNotificationTimeout);
            //vm.confirmRemoveFavorite(vm.hotelToRemoveCopy, true);
        }

        vm.hotelToRemoveCopy = vm.hotelToRemove;

        vm.showTimer = false;
        $timeout(() => {
            vm.showTimer = true;
        }, 0);

        vm.alertsFavorites.notificationSuccess = type === "success";
        vm.alertsFavorites.notificationError = type === "error";
        vm.alertsFavorites.notificationWarning = type === "warning";
        vm.alertsFavorites.message = message;
        vm.alertsFavorites.actionType = actionType;

        vm.hideNotificationTimeout = $timeout(vm.hideNotification, 6000);
    };

    vm.hideNotification = function () {
        vm.alertsFavorites.notificationSuccess = false;
        vm.alertsFavorites.notificationError = false;
        vm.alertsFavorites.notificationWarning = false;
        vm.alertsFavorites.message = "";
        vm.alertsFavorites.actionType = "";
    };

    vm.removeFavorites = function (event, hotel) {
        event.preventDefault();
        event.stopPropagation();
        vm.hotelToRemove = hotel;
        tracker.logDeleteFav(hotel, 'favsList');
        vm.confirmRemoveFavorite(hotel);
        vm.favoriteHotels = vm.favoriteHotels.filter(
            (favHotel) =>
                !(
                    favHotel.productId === hotel.productId &&
                    favHotel.checkin === hotel.checkin &&
                    favHotel.checkout === hotel.checkout &&
                    angular.equals(favHotel.rooms, hotel.rooms)
                )
        );
        vm.updateHotelsState();
        vm.checkForCheaperHotels();
        vm.showNotification("error", hotel.name, "delete");
    };
    vm.confirmRemoveFavorite = function (hotelRemove, isCopy) {
        if (hotelRemove) {
            service
                .removeHotel({ Id: hotelRemove.id, UserId: _userKey })
                .then((response) => { })
                .catch((error) => {
                    $scope.$applyAsync(() => {
                        vm.showNotification("error", "Failed to remove hotel.", "delete");
                    });
                    console.error("RemoveHotelError:", error);
                });
        }
    };
    vm.undoRemoveFavorite = function () {
        if (vm.hotelToRemove) {
            $timeout.cancel(vm.hideNotificationTimeout);
            const addHotelRequest = {
                UserId: _userKey,
                ...vm.hotelToRemove,
            };
            delete addHotelRequest.id;

            service
                .addHotel(addHotelRequest)
                .then((response) => {
                    $scope.$applyAsync(() => {
                        addHotelRequest.id = response.value;
                        vm.favoriteHotels.push(addHotelRequest);
                        vm.updateHotelsState();
                        vm.checkForCheaperHotels();
                        vm.alertsFavorites.notificationError = false;
                        vm.alertsFavorites.message = "";
                    });
                })
                .catch((error) => {
                    console.error("Error adding hotel back:", error);
                });
        }
    };
    function init() {

        if (fn.mobileAndTabletCheck()) {
            configDaysPrequote.weeksPrequote =
                config.configDaysPrequoteMobile.weeksPrequote;
            configDaysPrequote.daysPrequote =
                config.configDaysPrequoteMobile.daysPrequote;
            configDaysPrequote.startDate = config.configDaysPrequoteMobile.startDate;
        } else {
            configDaysPrequote.weeksPrequote =
                config.configDaysPrequoteDesktop.weeksPrequote;
            configDaysPrequote.daysPrequote =
                config.configDaysPrequoteDesktop.daysPrequote;
            configDaysPrequote.startDate = config.configDaysPrequoteDesktop.startDate;
        }

        const request = { UserId: _userKey, country: config.country.toUpperCase() };

        service
            .getHotelsByUser(request)
            .then((response) => {
                $scope.$applyAsync(() => {
                    vm.favoriteHotels = response.value;
                    vm.updateHotelsState();
                    tracker.logOpenFavsList('favsList', vm.favoriteHotels.length);
                    onLoadRates();
                });
            })
            .catch((error) => {
                console.error("Error fetching hotels by user:", error);
            });
    }
    vm.goBackFallback = () => {
        if (document.referrer !== "") {
            window.location.href = document.referrer;
        } else {
            window.location.href = "/";
        }
    };
    init();
    function getInitialDate(date = fn.getDate(), value = 0) {
        let dateNew = fn.getDate(fn.formatDate(date, setting.formatDate));
        dateNew.setDate(dateNew.getDate() + value);
        return fn.formatDate(dateNew, setting.formatDate)
    }
}
